<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="REGISTRO DE UBICACIONES" key="1">
      <g-master name="locationsmaster"
                :endpoint="locMaster.endpoint"
                :tableSetup="locMaster.tableSetup"
                :modalFieldsSetup="locMaster.modalFieldsSetup">
        <template slot="masterModal" slot-scope="{record}">
          <a-form-item label="Nombre" v-bind="fiOptions">
            <a-input
              v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </template>
      </g-master>
    </a-tab-pane>
    <a-tab-pane tab="REGISTRO DE DISTANCIAS" key="2">
      <g-master name="locatiodistsmaster"
                :endpoint="locDistMaster.endpoint"
                :tableSetup="locDistMaster.tableSetup"
                :modalFieldsSetup="locDistMaster.modalFieldsSetup">
        <template slot="masterModal" slot-scope="{record}">
          <g-dropdown endpoint="viaticos/locations"
                      :decorator="['id_loc_origin', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      label="Ubicación 1"
                      :cache="false"
                      :formItemConfig="fiOptions"/>

          <g-dropdown endpoint="viaticos/locations"
                      :decorator="['id_loc_destination', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      label="Ubicación 2"
                      :cache="false"
                      :formItemConfig="fiOptions"/>

          <a-form-item label="Distancia (Metros)" v-bind="fiOptions">
            <a-input-number
              style="width: 100%"
              :min="0"
              v-decorator="['distance', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>

          <a-form-item label="Valor Transporte" v-bind="fiOptions">
            <a-input-number
              style="width: 100%"
              :min="0"
              v-decorator="['travel_expenses', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>

          <a-form-item label="Distancia Bocatoma (Metros)" v-bind="fiOptions">
            <a-input-number
              style="width: 100%"
              :min="0"
              v-decorator="['distance_att_1', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>

          <a-form-item label="Distancia Planta (Metros)" v-bind="fiOptions">
            <a-input-number
              style="width: 100%"
              :min="0"
              v-decorator="['distance_att_2', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </template>
        <template slot="kmRender" slot-scope="{text}">
          {{parseInt(text) / 1000}}
        </template>
      </g-master>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  export default {
    data () {
      return {
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        locMaster: {
          endpoint: 'viaticos/locations',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'name'}
          ]
        },
        locDistMaster: {
          endpoint: 'viaticos/location_distances',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Ubicación 1', dataIndex: 'loc_origin', sorter: true},
              {title: 'Ubicación 2', dataIndex: 'loc_dest', sorter: true},
              {title: 'Distancia (KM)', dataIndex: 'distance', sorter: true, scopedSlots: {customRender: 'kmRender'}},
              {title: 'Valor del Transporte', dataIndex: 'travel_expenses', sorter: true},
              {title: 'Distancia Bocatoma (KM)', dataIndex: 'distance_att_1', sorter: true, scopedSlots: {customRender: 'kmRender'}},
              {title: 'Distancia Planta (KM)', dataIndex: 'distance_att_2', sorter: true, scopedSlots: {customRender: 'kmRender'}}
            ],
            customSlots: ['kmRender']
          },
          modalFieldsSetup: [
            {name: 'id_loc_origin'},
            {name: 'id_loc_destination'},
            {name: 'distance'},
            {name: 'travel_expenses'},
            {name: 'distance_att_1'},
            {name: 'distance_att_2'}
          ]
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Viaticos/Locations.vue